export * from './reservations.component';